import styled from 'styled-components'

export const Text = styled.span`
  font-size: 0.875em;
  line-height: 1.125em;
  color: ${({ theme }) => theme.darkGrey};
`
